import { Badge, Button } from "reactstrap";
import { usePettyCashBalance } from "hooks/usePettyCashMaster";
import { formatCurrency } from "utils/formatCurrency";

export const PettyCashBillListHeader = ({
  handleAddNewClick,
  handleTopUpClick,
  handleRefresh,
  total,
  isRefetching
}) => {
  const { data: balanceResponse } = usePettyCashBalance();
  const balance = balanceResponse?.data?.balance ?? 0;

  return (
    <div className="d-flex align-items-center mb-3">
      <h5 className="mb-0 mt-3 flex-grow-1">
        Total Bills <Badge color="info">{total ?? 0}</Badge>{" "}
        Petty Cash Balance{" "}
        <Badge color={balance < 0 ? "danger" : "success"}>
          {formatCurrency(balance, "BDT")}
        </Badge>
      </h5>

      <div className="flex-shrink-0">
        <Button color="success" onClick={handleTopUpClick} className="me-1">
          Top Up
        </Button>
        <Button color="primary" onClick={handleAddNewClick}>
          Create Bill
        </Button>
        <Button color="light" onClick={handleRefresh} className="ms-1">
          <i className={`mdi mdi-refresh ${isRefetching ? "mdi-spin" : ""}`} />
        </Button>
      </div>
    </div>
  );
};